import styled, { css } from 'styled-components';
import tw from 'twin.macro';

export const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Iframe = styled('iframe')`
  width: 100%;
  height: 100%;
`;

export const closeIconWrapperStyles = css`
  top: 0px;
  right: 0px;
  margin: 16px 16px 0px 0px;
`;

export const PaymentCancelConfirmationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const PaymentCancelConfirmationText = styled.span`
  ${tw`font-inter leading-6 mb-12 text-base font-medium text-lightBlueGray500`}
`;

export const CancelPaymentConfirmationModalButtonsContainer = styled.div`
  ${tw`flex justify-end`}
`;

export const CancelPaymentConfirmationModalButtons = styled.div`
  width: 40px;
  height: 30px;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  ${(props) => props.css}
`;

export const ConfirmButtonStyle = css`
  color: #fff;
  background-color: rgb(207, 17, 36);
  margin-left: 16px;
  box-shadow:
    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1px 0px 0px rgba(0, 0, 0, 0.08);
`;

export const CancelButtonStyle = css`
  color: #334155;
  border: 1px solid #cbd5e1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);
`;
